/**
 * Width for the photo grid cells, which are 204px square - about 400 physical pixels on
 * a 2x display. Clicking a cell opens the preview dialog, and that one keeps loading the
 * original.
 */
export const PHOTO_GRID_PREVIEW_WIDTH = 400

/**
 * Asks media storage for a downscaled copy of an image instead of the stored original.
 *
 * Storage rounds the width up to one of a few fixed sizes (200/400/800/1600), caches the
 * result and falls back to the original on its own when the file is not an image or is
 * already smaller than asked for - so this is safe to call for any file url without
 * knowing what is behind it.
 */
export const previewUrl = (url: string | null | undefined, width: number): string => {
    if (!url) {
        return ''
    }

    return `${url}${url.includes('?') ? '&' : '?'}w=${width}`
}
